/**
 * SectionOptions.js
 * Created by calhosh on 10/21/2020.
 */
import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';
import {labels} from '../../../../util/utils';
import ConfirmationModal from '../../Modal/Modal';
import AddEditCustomModal from '../../../Main/Forms/AddEditCustom/AddEditCustomModal';
import {clientSideEventNames, documentTypes} from '../../../../util/uiconstants';
import Dropdown from '../../BaseComponentWrappers/MotifDropdown';
import DropdownItem from '../../BaseComponentWrappers/MotifDropdownItem';
import MotifButton from '@ey/motif-react-wrapper/Button';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {useDocumentId, useEngagementId} from '../../../../util/customHooks';

export default function SectionOptions(props) {
	const {
		headerId,
		formData,
		id,
		isCustom,
		sectionName,
		sectionNameNoCustomLabel,
		saveResponse,
		showOptionsModal,
		sectionCustomLabel,
		isDuplicate,
		sectionOptionsActions
	} = props;
	const [isOpen, setIsOpen] = useState(false),
		[showModal, setShowModal] = useState(showOptionsModal),
		[modalType, setModalType] = useState(undefined);

	const documentId = useDocumentId(),
		engagementId = useEngagementId();

	const signOffs = useSelector((store) => store.signOffs);

	const handleClickDropdownItem = (type) => {
		setModalType(type);
		setShowModal(!showModal);
	};

	const setClickOutside = () => {
		setIsOpen(false);
	};

	const handleOptions = () => {
		setIsOpen(!isOpen);
	};

	const confirmActionClick = () => {
		setShowModal(false);
		saveResponse(modalType);
	};

	const cancel = () => {
		if (modalType === sectionOptionsActions.delete || modalType === sectionOptionsActions.duplicate) {
			setShowModal(false);
		}
		if (modalType === sectionOptionsActions.edit) {
			setShowModal(false);
		}
	};

	useEffect(() => {
		setShowModal(showOptionsModal);
	}, [showOptionsModal]);

	return (
		<>
			{props.documentTypeId !== documentTypes.PROFILEV2 && (
				<Dropdown
					open={isOpen}
					id={'sectionOption'}
					handleClickOutside={setClickOutside}
					trigger={
						<MotifButton
							id="dropdown-trigger"
							type="button"
							variant="ghost"
							title={labels.moreMenu}
							onClick={handleOptions}
							aria-expanded={isOpen}
						>
							<MotifIcon src={IconoirCustomMoreVerticalAlt} />
						</MotifButton>
					}
					children={
						<>
							{isCustom ? (
								<>
									<DropdownItem
										onClick={() => {
											handleClickDropdownItem(sectionOptionsActions.edit);
										}}
										children={labels.edit}
									/>
									<DropdownItem
										onClick={() => {
											handleClickDropdownItem(sectionOptionsActions.duplicate);
										}}
										children={labels.duplicate}
									/>
									<DropdownItem
										onClick={() => {
											handleClickDropdownItem(sectionOptionsActions.delete);
										}}
										children={labels.delete}
									/>
								</>
							) : (
								<>
									<DropdownItem
										onClick={() => {
											handleClickDropdownItem(sectionOptionsActions.edit);
										}}
										children={labels.edit}
									/>
									<DropdownItem
										onClick={() => {
											handleClickDropdownItem(sectionOptionsActions.duplicate);
										}}
										children={labels.duplicate}
									/>
									{isDuplicate && (
										<DropdownItem
											onClick={() => {
												handleClickDropdownItem(sectionOptionsActions.delete);
											}}
											children={labels.delete}
										/>
									)}
								</>
							)}
						</>
					}
				/>
			)}
			<ConfirmationModal
				show={
					(showModal && modalType === sectionOptionsActions.duplicate) ||
					(showModal && modalType === sectionOptionsActions.delete)
				}
				showButtons
				title={
					modalType && modalType === sectionOptionsActions.duplicate ? labels.duplicateSection : labels.deleteSection
				}
				bodyText={sectionName}
				confirmBtnTitle={modalType === sectionOptionsActions.duplicate ? labels.duplicate : labels.delete}
				cancelBtnTitle={labels.cancelLabel}
				onOkClick={confirmActionClick}
				onHide={cancel}
				closeTitle={labels.closeLabel}
				modalsize="small"
			>
				{modalType && modalType === sectionOptionsActions.duplicate ? (
					<section>
						{
							<>
								<p>{labels.duplicateSectionHeader}</p>
								<p>{sectionName}</p>
							</>
						}
					</section>
				) : (
					<>
						<p>{labels.deleteSectionHeader}</p>
						<p>{sectionName}</p>
					</>
				)}
			</ConfirmationModal>
			{showModal && modalType === sectionOptionsActions.edit && (
				<>
					<AddEditCustomModal
						afterSave={(headerId) => {
							setShowModal(false);
							window.dispatchEvent(
								new CustomEvent(clientSideEventNames.onCreateOrEdit, {
									detail: {selectedId: headerId, signOffs: signOffs, engagement: {engagementId: engagementId}}
								})
							);
							window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
						}}
						formData={formData}
						entityParentId={headerId}
						documentId={documentId}
						engagementId={engagementId}
						entity={'section'}
						entityId={id}
						entityValue={sectionName}
						entityWithNoCustomLabel={sectionNameNoCustomLabel}
						entityCustomLabel={sectionCustomLabel}
						isEdit
						isCustom={isCustom}
						onHide={cancel}
						showTabs={false}
					/>
				</>
			)}
		</>
	);
}
